import React, { PropsWithChildren } from 'react'
import './checkbox-card.scss';
import { List } from 'devextreme-react/list';
import DataSource from 'devextreme/data/data_source';

type Props<T> = {
    keyExpr: string,
    displayExpr: string,
    list: T[] | DataSource,
    selectedItems: any[],
    onValueChanged: (selectedValues: any[]) => void,
}

export const CheckBoxCard = <T,>({ keyExpr, displayExpr, list, selectedItems, onValueChanged }: PropsWithChildren<Props<T>>) => {

    const valueChanged = (args: any) => {
        if (args.name === 'selectedItems') {
            onValueChanged(args.value)
        }
    }

    const renderCheckBoxItem = (itemData: any) => {
        return (
            <div className={'checkbox-item'}>
                {itemData[displayExpr]}
            </div>
        )
    }

    return (
        <List
            scrollingEnabled={false}
            pageLoadMode={'nextButton'}
            dataSource={list}
            keyExpr={keyExpr}
            displayExpr={displayExpr}
            allowItemDeleting={false}
            showSelectionControls={true}
            selectionMode="multiple"
            selectedItems={selectedItems}
            onOptionChanged={valueChanged}
            itemRender={renderCheckBoxItem}
        >
        </List>
    )
}